import { createSlice } from "@reduxjs/toolkit";
import { getMetrcReceipts, getMetrcReceiptsSync } from "./metrcSalesActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  sales: {},
};

const metrcSalesSlice = createSlice({
  name: "metrcSales",
  initialState,
  reducers: {
    resetMetrcSaleError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetrcReceipts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMetrcReceipts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.sales = payload;
      })
      .addCase(getMetrcReceipts.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getMetrcReceiptsSync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMetrcReceiptsSync.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getMetrcReceiptsSync.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { resetMetrcSaleError } = metrcSalesSlice.actions;
export default metrcSalesSlice.reducer;
